import axios, {
	AxiosInstance,
	AxiosResponse,
	InternalAxiosRequestConfig,
} from "axios";
import { useRef } from "react";
import { camelToSnake, snakeToCamel } from "../../lib/objects";
import { AuthenticationProvider } from "../providers/authentication";

const useHttpProvider = () => {
	const httpRef = useRef<AxiosInstance>(null);

	if (!httpRef.current) {
		const baseURL = import.meta.env.VITE_SERVER_API_URL;
		const http = axios.create({
			baseURL,
		});

		http.interceptors.request.use(
			(configuration: InternalAxiosRequestConfig<any>) => {
				if (AuthenticationProvider.user?.accessToken) {
					configuration.headers.set(
						"Authorization",
						`Bearer ${AuthenticationProvider.user?.accessToken}`
					);
				}

				if (
					configuration.data &&
					typeof configuration.data === "object" &&
					!(configuration.data instanceof FormData)
				) {
					configuration.data = camelToSnake(configuration.data);
				}

				return configuration;
			},
			(error) => {
				return Promise.reject(error);
			}
		);

		http.interceptors.response.use(
			(response: AxiosResponse) => {
				return snakeToCamel(response.data);
			},
			(error: any) => {
				const response = error.response;

				if (response?.status === 401) {
					AuthenticationProvider.signout();
				}

				return Promise.reject(response?.data ?? error);
			}
		);

		httpRef.current = http;
	}

	return { http: httpRef.current };
};

export default useHttpProvider;
